import apiClient from './client';

export const reportsAPI = {
  /**
   * Получить опции для фильтров (сотрудники, клиенты, вендоры)
   */
  getFilterOptions: async () => {
    const response = await apiClient.get('/reports/filters');
    return response.data;
  },

  /**
   * Сформировать отчёт с фильтрами
   * @param {Object} request - Запрос отчёта
   * @param {Object} request.filters - Фильтры
   * @param {string} request.view_mode - "table" | "pivot"
   * @param {Object} request.pivot_config - Конфигурация pivot (если view_mode === "pivot")
   */
  generateReport: async (request) => {
    const response = await apiClient.post('/reports/generate', request);
    return response.data;
  },

  /**
   * Получить данные о нагрузке команды менеджеров (P0 BI-ADVANCED)
   */
  getTeamWorkload: async () => {
    const response = await apiClient.get('/reports/team-workload');
    return response.data;
  },

  // === PRESETS ===

  /**
   * Получить список пресетов
   */
  getPresets: async () => {
    const response = await apiClient.get('/reports/presets');
    return response.data;
  },

  /**
   * Создать пресет
   */
  createPreset: async (preset) => {
    const response = await apiClient.post('/reports/presets', preset);
    return response.data;
  },

  /**
   * Обновить пресет
   */
  updatePreset: async (presetId, preset) => {
    const response = await apiClient.put(`/reports/presets/${presetId}`, preset);
    return response.data;
  },

  /**
   * Удалить пресет
   */
  deletePreset: async (presetId) => {
    const response = await apiClient.delete(`/reports/presets/${presetId}`);
    return response.data;
  },
};
